export function getProductImpressionData(
	product: {
		name?: string | null;
		sku?: string | null;
		brand?: string | null;
		price: { excludingTax: number };
	} | null,
	ga4?: true,
	category?: string,
) {
	if (!product) {
		return {};
	}

	const item_brand = ga4 && product.brand !== "No" && product.brand !== "Nee" ? product.brand : "";

	return {
		[ga4 ? "item_name" : "name"]: product.name,
		[ga4 ? "item_id" : "id"]: product.sku,
		price: product.price.excludingTax,
		item_brand: item_brand,
		item_category: category,
	};
}
